import type { RouteObject } from 'react-router-dom';
import { Navigate, useParams } from 'react-router-dom';
import { LibraryPage } from '~/pages/library/library';
import { stylesRoute } from '~/router/app/library/styles';
import { templatesRoute } from '~/router/app/library/templates';
import { formsRoute } from '~/router/app/library/forms';
import { wordTemplatesRoute } from '~/router/app/library/word-templates';
import { excelTemplatesRoute } from '~/router/app/library/excel-templates';
import {
  emailTemplateEditorRoute,
  emailTemplatesRoute
} from '~/router/app/library/email-templates';

/** Legacy `/app/styles/*` → `/app/library/styles/*` */
function RedirectLegacyStylesToLibrary() {
  const params = useParams();
  const splat = params['*'] ?? '';
  return <Navigate to={splat ? `/app/library/styles/${splat}` : '/app/library/styles'} replace />;
}

export const libraryRoutes: RouteObject[] = [
  {
    id: 'library',
    path: 'library',
    element: <LibraryPage />,
    children: [
      {
        index: true,
        element: <Navigate to="styles" replace />
      },
      stylesRoute,
      templatesRoute,
      formsRoute,
      wordTemplatesRoute,
      excelTemplatesRoute,
      emailTemplatesRoute
    ]
  },
  emailTemplateEditorRoute,
  {
    path: 'styles/*',
    element: <RedirectLegacyStylesToLibrary />
  }
];
